(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-value-prop-banner"] && !Shopify.designMode) return;
  try {
    let shippingSlideIndex = 0;

  if (window.innerWidth <= 768) {
    shippingShowSlides();
  }

  function shippingShowSlides() {
    let i;
    let slides = document.getElementsByClassName('shipping-banner__item');

    for (i = 0; i < slides.length; i++) {
      slides[i].classList.remove('active');
    }

    shippingSlideIndex++;
    if (shippingSlideIndex > slides.length) {
      shippingSlideIndex = 1;
    }

    slides[shippingSlideIndex - 1].classList.add('active');
    setTimeout(shippingShowSlides, 3000);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pagination"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.body.addEventListener('click', function (e) {
      const link = e.target.closest('.pagination a');
      if (!link) return;

      e.preventDefault();

      const search_page = document.body.classList.contains('search-page');
      fetch(link.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Find all ajax containers
          const newContainers = doc.querySelectorAll('[data-ajax-container]');
          let firstReplaced = null;
          let currentContainer;
          newContainers.forEach((newContainer, index) => {
            let id = newContainer.getAttribute('data-ajax-container');
            if(search_page) {
              const search_wrapper = link.closest('.search-content-wrapper');
              if(search_wrapper) {
                currentContainer = search_wrapper.querySelector(`[data-ajax-container="collection"]`);
              }
            } else {
              currentContainer = document.querySelector(`[data-ajax-container="${id}"]`);
            }
            if (currentContainer) {
              currentContainer.innerHTML = newContainer.innerHTML;
              if (index === 0) firstReplaced = currentContainer;
            }
          });

          // Replace pagination itself
          const newPagination = doc.querySelector('.pagination');
          let currentPagination;
          if(search_page) {
            currentPagination = link.closest('.pagination');
          } else {
            currentPagination = document.querySelector('.pagination');
          }
          if (newPagination && currentPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          }

          // Scroll to the first replaced AJAX container
          if (firstReplaced) {
            const rect = firstReplaced.getBoundingClientRect();
            const scrollTop = window.scrollY || window.pageYOffset;
            const nav = document.querySelector('#main-navigation');
            const navHeight = nav ? nav.offsetHeight : 0;
            const targetY = rect.top + scrollTop - navHeight - 40;

            window.scrollTo({ top: targetY, behavior: 'smooth' });
          }
        })
        .catch((err) => console.error('AJAX pagination error:', err));
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorting"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');

    if (window.innerWidth <= 768) {
      const popup = document.getElementById('sortPopup');
      const openBtn = document.querySelector('.facets__summary[role="button"]');
      const closeBtn = document.getElementById('closeSortPopup');
      const applyBtn = document.getElementById('applySort');

      // Open popup
      openBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        popup.style.display = 'flex';
      });

      // Close popup
      closeBtn?.addEventListener('click', () => {
        popup.style.display = 'none';
      });

      // Close when clicking outside
      popup?.addEventListener('click', (e) => {
        if (e.target === popup) {
          popup.style.display = 'none';
        }
      });

      // Apply sort
      applyBtn?.addEventListener('click', () => {
        const selected = document.querySelector('.sort-popup-mobile input[name="sort_by"]:checked');
        if (selected) {
          const formId = selected.getAttribute('form');
          const form = formId ? document.getElementById(formId) : selected.closest('form');
          if (form) {
            form.submit(); // Submit the Shopify filter form
          }
          popup.style.display = 'none';
        }
      });

      // Set default checked input from URL
      if (sortBy) {
        const container = document.querySelector('.sort-popup-mobile');
        if (container) {
          const matchingInput = container.querySelectorAll(`input[name="sort_by"][value="${sortBy}"]`);
          matchingInput.forEach((input) => {
            input.checked = true;
            input.dispatchEvent(new Event('change'));
          });
        }
      }
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    document.querySelectorAll('variant-picker[data-section-id]').forEach((variantPicker) => {
      // Handle radio buttons
      variantPicker.querySelectorAll('.variant-option input[type="radio"]').forEach((input) => {
        input.addEventListener('change', function () {
          if (this.checked) {
            const fieldset = this.closest('.variant-option');
            const swatchValueEl = fieldset.querySelector('.variant-option__swatch-value');
            if (swatchValueEl) {
              swatchValueEl.textContent = this.value;
            }
          }
        });
      });

      // Handle dropdowns
      variantPicker.querySelectorAll('.variant-option__select').forEach((select) => {
        select.addEventListener('change', function () {
          const wrapper = this.closest('.variant-option');
          const swatchValueEl = wrapper.querySelector('.variant-option__swatch-value');
          if (swatchValueEl) {
            const selectedOption = this.options[this.selectedIndex];
            swatchValueEl.textContent = selectedOption.textContent.trim();
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
